import type { AppDispatch } from "../store/store";
import { logout } from "../store/slices/authSlice";
import { clearCurrentUser } from "../store/slices/userSlice";
import { resetChatState } from "../store/slices/chatSlice";
import { removeDeviceForNotifications } from "../store/slices/notificationSlice";
import { setLoaderState } from "../store/slices/loaderSlice";
import { resetAbly } from "../services/ablyChatClient";
import { CHAT_INIT_SESSION_KEY } from "./constants";
import { clearPendingOnboardingUserId } from "./pendingOnboarding";
import { tokenStorage } from "./tokenStorage";

export type PerformLogoutOptions = {
  redirectTo?: string;
};

/**
 * Clears client session state. Uses a full page redirect by default so the router
 * does not briefly render protected or 404 routes while auth is tearing down.
 */
export async function performLogout(
  dispatch: AppDispatch,
  options: PerformLogoutOptions = {}
): Promise<void> {
  const redirectTo = options.redirectTo ?? "/";

  resetAbly();
  dispatch(resetChatState());

  try {
    await dispatch(removeDeviceForNotifications());
  } catch {
    // Device removal may fail when the session is already invalid.
  }

  if (typeof window === "undefined") {
    dispatch(logout());
    dispatch(clearCurrentUser());
    dispatch(setLoaderState(false));
    return;
  }

  sessionStorage.removeItem(CHAT_INIT_SESSION_KEY);
  clearPendingOnboardingUserId();

  const targetPath = redirectTo.split("?")[0];
  if (window.location.pathname !== targetPath) {
    tokenStorage.clearTokens();
    window.location.replace(redirectTo);
    return;
  }

  dispatch(logout());
  dispatch(clearCurrentUser());
  dispatch(setLoaderState(false));
}
